import { saveUploadConfiguration } from '../utils'
import { CustomizationFieldValue } from '../../types'
import isEmpty from 'lodash/isEmpty'
import { TDesignJourney } from '../../../../_types'
import { NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_COUNTRY } from '@utils/client-side-config'
import { newDesignJourneyToLegacy } from '../../../../_utils'
import { DESIGN_PATHS } from '../../../constants'

function generatePreviewLink({ configId }: { configId: string }) {
  return `${window.location.origin}${window.location.pathname}?configId=${configId}&readOnly=true&siteRegion=${NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_COUNTRY}`
}

/**
 * Get the key of design journey.
 * Currently, we only support mapping the v1 -> upload, v3 -> briefing.
 * Feel free to add more params to support v2 editor.
 * @param brief {object}
 * @return the key of design journey
 */
function getDesignJourney(brief): TDesignJourney {
  if (isEmpty(brief)) {
    return DESIGN_PATHS.DESIGN_UPLOAD
  } else {
    return DESIGN_PATHS.BRIEFING_FORM
  }
}

/**
 * It will generate the configuration for storing in customization fields.
 * However, because we need to generate preview link which needs configId persisted
 * hence this method has to **store configuration** first
 *
 * @param productCategorySlug
 * @param selection
 * @param brief
 * @param filesUrls
 */
export async function toCustomizationFields({
  productCategorySlug,
  selection,
  brief,
  onlineEditor,
  filesUrls,
  designJourney,
  qrCodeChoice,
}): Promise<CustomizationFieldValue> {
  const configuration = {
    variantId: selection.variantId,
    variantSku: selection.variantSku,
    brief,
    onlineEditor,
    version: newDesignJourneyToLegacy[designJourney],
    filesUrls,
    productCategorySlug, // It needs for cart?
    designJourney: designJourney,
    qrCodeChoice,
  }

  const configId = await saveUploadConfiguration(configuration)
  const previewLink = generatePreviewLink({
    configId,
  })

  return {
    variantId: selection.variantId,
    version: newDesignJourneyToLegacy[designJourney],
    filesUrls,
    previewLink,
    configId, // Need this for previewing
    productCategorySlug, // It needs for cart?
    brief,
    onlineEditor,
    designJourney: designJourney,
    qrCodeChoice,
  }
}
